import { Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-ayuda-atajo-modal',
  templateUrl: './ayuda-atajo-modal.component.html',
  styleUrls: ['./ayuda-atajo-modal.component.css']
})
export class AyudaAtajoModalComponent implements OnInit {

  ayudaForm: FormGroup;
  show  = false;
  seleccionado = false;

  constructor(public dialogRef: MatDialogRef<AyudaAtajoModalComponent>, 
    private router: Router) { }

  ngOnInit(): void {
    sessionStorage.setItem('tipo', "");
    this.initForm();
  }

  initForm(): void{
    this.ayudaForm = new FormGroup({
      tipoTramite : new FormControl('', Validators.required),
      km : new FormControl(''),
      paisOrigen: new FormControl(''),
      numPedido: new FormControl('')

    });
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.router.navigate(['page/home']);
  }

  onSiguiente(): void {
    this.dialogRef.close();
    sessionStorage.setItem('numPedido', this.ayudaForm.get('numPedido').value);
    this.router.navigate(['page/ayudas']).then(() => {
      window.location.reload();
    });
  }

  changeEstado(event): void{
    console.log(event.value);
    sessionStorage.setItem('tipo', event.value);
    this.seleccionado=true;
    /*
    switch (event.value){
      case ('MATRICULACION USADO IMPORTACION'):
        this.show  = true;
        this.ayudaForm.get('km').setValidators(Validators.required);
        this.ayudaForm.get('paisOrigen').setValidators(Validators.required);
        this.ayudaForm.get('km').enabled === false ? this.ayudaForm.get('km').enable() : null;
        this.ayudaForm.get('paisOrigen').enabled === false ? this.ayudaForm.get('paisOrigen').enable() : null;


        break;

        default:
        this.show = false;
        this.ayudaForm.get('km').setValidators(null);
        this.ayudaForm.get('paisOrigen').setValidators(null);
        this.ayudaForm.get('km').disable();
        this.ayudaForm.get('paisOrigen').disable();
        break;
    }
        */
  }
}
